import {setupRenaissanceKeepaliveIfNecessary} from '@freckle/educator-entities/ts/common/helpers/renaissance-keepalive'
import type {SchoolAdminAttrs} from '@freckle/school/ts/users/models/school-admin'

export function setupRenaissanceKeepalive(selfSchoolAdmin: SchoolAdminAttrs) {
  //setupRenaissanceKeepaliveIfNecessary is IIFE based.  Running multiple times will
  //not create multiple intervals.
  setupRenaissanceKeepaliveIfNecessary(selfSchoolAdmin.renaissanceKeepalive)
}
